<template>
  <div class="card">
    <div
      class="card-body"
      :style="!padding ? 'px-0 py-0': ''"
    >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    padding: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .card {
    background-color: #fff;
    border-radius: 0;
    box-shadow: 0 5px 15px 0 rgba(37,44,97,.15), 0 2px 4px 0 rgba(93,100,148,.2);
  }
  .card-body {
    padding: 2.5rem;
  }
</style>
